import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { Typography } from '@mui/material';
import i18next from 'i18next';
import { KeyboardEvent, memo, useCallback } from 'react';

import { MultiStoreCenterDay } from '../../../../interface/multi-store';
import { handleActivationKey } from './multi-store-a11y';
import { MultiStoreCardFrame } from './multi-store-card-frame';
import { MultiStoreCenterContent } from './multi-store-center-content';

interface MultiStoreFreeCardProps {
  center: MultiStoreCenterDay;
  hour: string;
  // l'appuntamento sarà con il primo operatore disponibile
  isAnyUser: boolean;
  // unica scheda del gruppo raggiungibile col Tab (tabindex mobile)
  isTabStop: boolean;
  onFocusCenter: (pointOfSaleId: string) => void;
  onSwitch: (center: MultiStoreCenterDay, hour: string) => void;
}

// Centro libero all'orario scelto, attivo se è il centro corrente: il tocco, Invio o la barra
// spaziatrice cambiano centro tenendo giorno e ora
export const MultiStoreFreeCard = memo(function MultiStoreFreeCard({
  center,
  hour,
  isAnyUser,
  isTabStop,
  onFocusCenter,
  onSwitch,
}: MultiStoreFreeCardProps): JSX.Element {
  const handleSelect = useCallback(() => {
    if (!center.isCurrent) onSwitch(center, hour);
  }, [center, hour, onSwitch]);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLDivElement>) => {
      handleActivationKey(event, handleSelect);
    },
    [handleSelect]
  );

  const handleFocus = useCallback(() => {
    onFocusCenter(center.pointOfSale.id);
  }, [center.pointOfSale.id, onFocusCenter]);

  return (
    <div
      role="radio"
      aria-checked={center.isCurrent}
      tabIndex={isTabStop ? 0 : -1}
      className="multi-store-card-target"
      onClick={handleSelect}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
    >
      <MultiStoreCardFrame isSelectable isActive={center.isCurrent}>
        <MultiStoreCenterContent
          pointOfSale={center.pointOfSale}
          isOrigin={center.isOrigin}
          distance={center.distance}
        >
          <div className="multi-store-card-line">
            <CheckCircleOutlinedIcon color="primary" />
            <Typography variant="contentDescription2">
              {i18next.t('pages.when.multi_store.free_at', { hour })}
            </Typography>
          </div>
          {isAnyUser && (
            <Typography variant="contentDescription2">
              {i18next.t('pages.when.multi_store.first_available_user')}
            </Typography>
          )}
        </MultiStoreCenterContent>
      </MultiStoreCardFrame>
    </div>
  );
});
